import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        userinfo:{
            status:0,
        }
    },
    getters:{
        userinfo(state){
            return state.userinfo
        }
    },
    mutations:{
        setinfo(state,info){
            state.userinfo = info;
        }
    },
    actions:{
        setinfo(state,info){
            state.commit('setinfo',info);
        }
    }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js